import { h, Component } from 'preact';
import { joinClasses } from 'utils/utils';
import { glyphs } from 'helpers/airportData';
import Store from 'store/store';
import s from 'components/bolt/airport/glyphs/glyphs.sss';

export default class Glyphs extends Component {

	constructor(props) {
		super(props);

		this.state = {
			isHoveringOnAnim: false,
			currentGlyph: undefined,
			currentParentIndex: undefined
		};
		this.onAnimComplete = this.onAnimComplete.bind(this);
		
		this.glyphs = glyphs.filter(s => !s.disabled);
	}

	onAnimHover(glyph, parentIndex) {
		if (this[`$anim${glyph.id}${parentIndex}`]) {
			this[`$anim${glyph.id}${parentIndex}`].currentTime = 0;
			this[`$anim${glyph.id}${parentIndex}`].play();
		}
		this.setState({ isHoveringOnAnim: true, currentGlyph: glyph, currentParentIndex: parentIndex });
	}

	onAnimUnhover(glyph, parentIndex) {
		if (this[`$anim${glyph.id}${parentIndex}`]) {
			this[`$anim${glyph.id}${parentIndex}`].currentTime = 0;
			this[`$anim${glyph.id}${parentIndex}`].pause();
		}
		this.setState({ isHoveringOnAnim: false });
	}

	onAnimComplete() {
		Store.emit('ROB_UPDATE', 'glyph');
	}

	renderGlyphCodes(parentIndex) {
		const { imageRoot, videoRoot } = this.props;
		const { isHoveringOnAnim, currentGlyph, currentParentIndex } = this.state;

		return (
			<div 
				class={s.codeGlyphs} 
			>
				{this.glyphs.map((glyph, i) => (
					[
						<div
							class={s.anim}
							key={`anim-${i}-${parentIndex}`}
							onMouseEnter={() => this.onAnimHover(glyph, parentIndex)}
							onMouseLeave={() => this.onAnimUnhover(glyph, parentIndex)}
						>
							<video
								poster={`${imageRoot}/airport/glyphs/${glyph.anim}/0.png`}
								class={joinClasses(
									s.animVideo,
									(isHoveringOnAnim && currentGlyph.id === glyph.id && currentParentIndex === parentIndex) && s.active
								)}
								muted
								playsinline
								ref={($ref) => this[`$anim${glyph.id}${parentIndex}`] = $ref}
								onEnded={this.onAnimComplete}
							>
								<source src={`${videoRoot}/airport/glyphs/${glyph.anim}.mov`} type={'video/mp4'} />
								<source src={`${videoRoot}/airport/glyphs/${glyph.anim}.webm`} type={'video/webm'} />
							</video>
							<img
								src={`${imageRoot}/airport/glyphs/${glyph.anim}/0.png`}
								class={joinClasses(
									s.animFirstFrame,
									(isHoveringOnAnim && currentGlyph.id === glyph.id && currentParentIndex === parentIndex) && s.hidden
								)}
							/>
						</div>,
						<img class={s.filler} src={`${imageRoot}/airport/glyphs/with-hyphen/${i + 1}.webp`} key={`first-filler-${i}-${parentIndex}`} />,
						<img class={s.filler} src={`${imageRoot}/airport/glyphs/no-hyphen/${i + 2}.webp`} key={`second-filler-${i}-${parentIndex}`} />,
						<img class={s.filler} src={`${imageRoot}/airport/glyphs/with-hyphen/${i + 3}.webp`} key={`third-filler-${i}-${parentIndex}`} />
					]
				))}
			</div>
		);
	}

	render({ imageRoot, client, motionPaused }) {
		const { isHoveringOnAnim } = this.state;

		const codesEnabled = client?.device === 'desktop';

		return (
			<div class={joinClasses(s.container, codesEnabled && s.withCodes, (isHoveringOnAnim || motionPaused) && s.motionPaused )}>
				<div class={s.scroller}>
					{new Array(2).fill('x').map((x, i) => (
						<div class={joinClasses(s.glyphStrip, s[`glyphStrip${i}`])} key={`glyph-strip${i}`}>
							{codesEnabled ? this.renderGlyphCodes(i) : <img src={`${imageRoot}/airport/8yr1ev.png`} />}
						</div>
					))}
				</div>
			</div>
		);
	}
}